import { render, staticRenderFns } from "./MandalaEvaluationForm.vue?vue&type=template&id=5a488a20&scoped=true&"
import script from "./MandalaEvaluationForm.vue?vue&type=script&lang=js&"
export * from "./MandalaEvaluationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a488a20",
  null
  
)

export default component.exports